import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@portal-core/auth/services/api.service';
import { Build } from '@portal-core/builds/models/build.model';
import { LicenseHostMapProfile } from '@portal-core/profiles/models/license-host-map-profile.model';
import { LicenseProfile } from '@portal-core/profiles/models/license-profile.model';
import { ProjectChecklistProfile } from '@portal-core/profiles/models/project-checklist-profile.model';
import { ProjectProfile } from '@portal-core/profiles/models/project-profile.model';
import { ReviewFileProfile } from '@portal-core/profiles/models/review-file-profile.model';
import { ReviewPackageProfile } from '@portal-core/profiles/models/review-package-profile.model';
import { SiteProfile } from '@portal-core/profiles/models/site-profile.model';
import { UserProfile } from '@portal-core/profiles/models/user-profile.model';
import { Publication } from '@portal-core/publications/models/publication.model';
import { TranslationPackageLanguageBranchProfile } from '@portal-core/translation-package-language-branches/models/translation-package-language-branch-profile.model';
import { TranslationPackageProfile } from '@portal-core/translation-packages/models/translation-package-profile.model';
import { SharePendingRequest } from '@portal-core/util/observables.decorators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfilesApiService {
  constructor(private http: HttpClient, private apiService: ApiService) { }

  @SharePendingRequest()
  getProjectProfile$(projectId: number): Observable<ProjectProfile> {
    return this.http.get<ProjectProfile>(`${this.apiService.centralApiBaseUri}/api/projects/projectProfile/${projectId}`);
  }

  @SharePendingRequest()
  getReviewFileProfile$(reviewId: number): Observable<ReviewFileProfile> {
    return this.http.get<ReviewFileProfile>(`${this.apiService.centralApiBaseUri}/api/Reviews/ReviewProfile/${reviewId}`);
  }

  @SharePendingRequest()
  getReviewPackageProfile$(reviewPackageId: number): Observable<ReviewPackageProfile> {
    return this.http.get<ReviewPackageProfile>(`${this.apiService.centralApiBaseUri}/api/ReviewPackage/Profile/${reviewPackageId}`);
  }

  @SharePendingRequest()
  getUserProfile$(userId: string, licenseId: number): Observable<UserProfile> {
    return this.http.get<UserProfile>(`${this.apiService.centralApiBaseUri}/api/users/userProfile/${userId}/${licenseId}`);
  }

  @SharePendingRequest()
  getLicenseHostMapProfile$(licenseHostMapId: number): Observable<LicenseHostMapProfile> {
    return this.http.get<LicenseHostMapProfile>(`${this.apiService.centralApiBaseUri}/api/Licensehostmap/licenseHostMapProfile/${licenseHostMapId}`);
  }

  @SharePendingRequest()
  getBuildProfile$(buildId: number): Observable<Build> {
    return this.http.get<Build>(`${this.apiService.centralApiBaseUri}/api/builds/buildProfile/${buildId}`);
  }

  @SharePendingRequest()
  getPublicationProfile$(publicationId: number): Observable<Publication> {
    return this.http.get<Publication>(`${this.apiService.centralApiBaseUri}/api/publications/publicationProfile/${publicationId}`);
  }

  @SharePendingRequest()
  getTranslationPackageProfile$(translationPackageId: number): Observable<TranslationPackageProfile> {
    return this.http.get<TranslationPackageProfile>(`${this.apiService.centralApiBaseUri}/api/translationPackage/${translationPackageId}/getPackageProfile`);
  }

  @SharePendingRequest()
  getTranslationPackageLanguageBranchProfile$(translationPackageLanguageBranchId: number): Observable<TranslationPackageLanguageBranchProfile> {
    return this.http.get<TranslationPackageLanguageBranchProfile>(`${this.apiService.centralApiBaseUri}/api/translationPackageLanguageBranch/${translationPackageLanguageBranchId}/getLanguageBranchProfile`);
  }

  @SharePendingRequest()
  getSiteProfile$(siteId: number): Observable<SiteProfile> {
    return this.http.get<SiteProfile>(`${this.apiService.centralApiBaseUri}/api/sites/${siteId}/GetSiteProfile`);
  }

  @SharePendingRequest()
  getLicenseProfile$(licenseId: number): Observable<LicenseProfile> {
    return this.http.get<LicenseProfile>(`${this.apiService.centralApiBaseUri}/api/licenses/licenseProfile/${licenseId}`);
  }

  @SharePendingRequest()
  getProjectChecklistProfile$(checklistId: number): Observable<ProjectChecklistProfile> {
    return this.http.get<ProjectChecklistProfile>(`${this.apiService.centralApiBaseUri}/api/checklists/${checklistId}/profile`);
  }
}
